<form class="card mt-2" *ngIf="canEdit">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-start mb-3">
      <div class="text-right" *ngIf="loadingUserEquipments">
        <div class="text-muted small">Loading assigned assets...</div>
        <i class="material-icons rotate text-muted">loop</i>
      </div>
    </div>

    <div class="row" *ngIf="!isDirectSelectionMode">
      <div class="col-12">
        <h5>Scan Barcode</h5>
        <div class="d-flex align-items-start gap-2">
          <input type="text" class="form-control mt-2 mr-2" [(ngModel)]="barcode" (ngModelChange)="onBarcodeInputChange()" [ngModelOptions]="{standalone: true}" placeholder="Scan or enter barcode..." [disabled]="disableReturnControls"
            (keydown.enter)="onBarcodeEnterKey($event)" />
          <button type="button" class="btn btn-secondary mt-2" (click)="lookupBarcode()" [disabled]="barcodeLookupLoading || disableReturnControls">Lookup</button>
        </div>
        <small class="text-muted">Use this for barcode-driven returns. After lookup, choose the matching active assignment and complete the required return note.</small>
        <div *ngIf="barcodeLookupLoading" class="mt-2 text-muted">Looking up barcode...</div>
        <div *ngIf="barcodeLookupError" class="mt-2 text-danger">{{barcodeLookupError}}</div>

        <div *ngIf="barcodeLookupResult?.found" class="card mt-3">
          <div class="card-body">
            <div><b>Type:</b> {{barcodeLookupResult.assetType}}</div>
            <div><b>Category:</b> {{barcodeLookupResult.assetCategory}}</div>
            <div><b>Description:</b> {{barcodeLookupResult.description}}</div>
            <div><b>Serial:</b> {{barcodeLookupResult.serialNumber || '-'}}</div>
            <div class="mt-3">
              <button
                type="button"
                class="btn btn-secondary mr-2 mb-2"
                *ngFor="let option of barcodeLookupResult.options"
                (click)="queueBarcodeReturn(option)"
                [disabled]="disableReturnControls">
                {{option.actionLabel}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-xl-3">
        <label>Assignment Type</label>
        <p-select styleClass="app-select mt-2"
                  [options]="[{label:'User', value:'user'},{label:'Campus', value:'campus'}]"
                  [(ngModel)]="returnTargetType"
                  (ngModelChange)="changedReturnTargetType()"
                  [ngModelOptions]="{standalone: true}"
                  [disabled]="disableReturnControls"></p-select>
      </div>
      <div class="col-12 col-xl-6" *ngIf="returnTargetType === 'user'">
        <label>User</label>
        <p-select styleClass="app-select mt-2"
                  [options]="usersList"
                  [(ngModel)]="userID"
                  [filter]="true"
                  [resetFilterOnHide]="true"
                  (ngModelChange)="changedUser()"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Select user..."
                  [disabled]="disableReturnControls"></p-select>
        <div style="font-size:.75rem;" class="mt-2">
          <label for="includeTerminated">Include Separated Employees: </label>
          <p-checkbox id="includeTerminated" name="includeTerminated" styleClass="form-check-input ml-4" [(ngModel)]="includeTerminated" (onChange)="includeTerminatedChange($event)" [disabled]="disableReturnControls" [binary]="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
        </div>
        <small *ngIf="showErrors && !userID" class="text-danger">Select a user to return assets for</small>
      </div>
      <div class="col-12 col-xl-6" *ngIf="returnTargetType === 'campus'">
        <label>Campus</label>
        <p-select styleClass="app-select mt-2"
                  [options]="returnCampusList"
                  [(ngModel)]="assignedProgramID"
                  [filter]="true"
                  [resetFilterOnHide]="true"
                  (ngModelChange)="changedCampus()"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Select campus..."
                  [disabled]="disableReturnControls"></p-select>
        <small *ngIf="showErrors && !assignedProgramID" class="text-danger">Select a campus to return assets for</small>
      </div>
    </div>

    <div class="row" *ngIf="barcodeOnlyReturns.length > 0">
      <div class="col-12">
        <h5 class="mt-3">Scanned Returns</h5>
        <p-table class="mt-2" styleClass="barcode-returns-table" [value]="barcodeOnlyReturns" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th width="110px"></th>
              <th>Action</th>
              <th>Type</th>
              <th>Description</th>
              <th>Barcode</th>
              <th>Return To Location</th>
              <th>Status</th>
              <th>Condition</th>
              <th>Return Note</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-equipment>
            <tr [class.return-row--select-open]="isBarcodeReturnSelectOpen(equipment)">
              <td>
                <button type="button" class="btn btn-secondary mr-2" (click)="removeBarcodeOnlyReturn(equipment)" [disabled]="disableReturnControls">Remove</button>
              </td>
              <td>{{equipment.actionLabel}}</td>
              <td>{{equipment.equipment.type}}</td>
              <td>{{equipment.description}}</td>
              <td>{{equipment.barcode || '-'}}</td>
              <td>
                <p-select styleClass="app-select mt-2" [options]="locationList" [(ngModel)]="equipment.assetLocationID" (ngModelChange)="changedBarcodeOnlyReturn()" [ngModelOptions]="{standalone: true}" placeholder="Select location..." [disabled]="disableReturnControls" [filter]="true" [resetFilterOnHide]="true"
                  (onShow)="onBarcodeReturnSelectShow(equipment)" (onHide)="onBarcodeReturnSelectHide(equipment)"></p-select>
                <small *ngIf="showErrors && !equipment.assetLocationID" class="text-danger">Return-to location is required</small>
              </td>
              <td>
                <p-select styleClass="app-select mt-2" [options]="returnStatusOptions" [(ngModel)]="equipment.assetReturnStatusID" (ngModelChange)="changedBarcodeOnlyReturn()" [ngModelOptions]="{standalone: true}" [disabled]="disableReturnControls"
                  (onShow)="onBarcodeReturnSelectShow(equipment)" (onHide)="onBarcodeReturnSelectHide(equipment)"></p-select>
              </td>
              <td>
                <p-select *ngIf="equipment.requireItemCondition && (equipment.allowedAssetItemConditions?.length > 0)"
                          styleClass="app-select mt-2"
                          [options]="equipment.allowedAssetItemConditions"
                          optionLabel="assetItemCondition"
                          optionValue="id"
                          [(ngModel)]="equipment.assetItemConditionID"
                          (ngModelChange)="changedBarcodeOnlyReturn()"
                          [ngModelOptions]="{standalone: true}"
                          [disabled]="disableReturnControls"></p-select>
                <small *ngIf="showErrors && equipment.requireItemCondition && (equipment.allowedAssetItemConditions?.length > 0) && !equipment.assetItemConditionID"
                       class="text-danger">Condition is required</small>
              </td>
              <td>
                <textarea class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="equipment.returnNotes" (ngModelChange)="changedBarcodeOnlyReturn()" [disabled]="disableReturnControls"></textarea>
                <small *ngIf="showErrors && (!equipment.returnNotes || !equipment.returnNotes.trim())" class="text-danger">Return note is required</small>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="row" *ngIf="hasReturnTargetSelection">
      <div class="col-12 pb-4">
        <h5 class="mt-3">Assigned Assets</h5>
        <div *ngIf="showNoAssetsToReturnMessage" class="alert alert-info mt-2 mb-0 py-2">
          No assets to return for the selected {{returnTargetType}}.
        </div>
        <ng-container *ngIf="!showNoAssetsToReturnMessage">
        <p-table class="mt-2" styleClass="assigned-assets-return-table" [value]="assignedEquipmentsToUser" [responsive]="true" [rowTrackBy]="trackByFn">
            <ng-template pTemplate="header">
              <tr>
                <th>Returned</th>
                <th>Type</th>
                <th>Category</th>
                <th>Description</th>
                <th>Serial</th>
                <th>Barcode</th>
                <th>Assigned From Location</th>
                <th>Return Due</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-equipment>
              <tr>
                <td>
                  <p-checkbox [ngModelOptions]="{standalone: true}" [(ngModel)]="equipment.returned" (ngModelChange)="changedEquipment(equipment)" [binary]="true" [disabled]="disableReturnControls"></p-checkbox>
                </td>
                <td>
                  {{equipment.equipment.type}}
                </td>
                <td>
                  {{equipment.assetCategory || '-'}}
                </td>
                <td>
                  {{equipment.description}}
                </td>
                <td>
                  {{equipment.equipment.serialNumber || '-'}}
                </td>
                <td>
                  {{equipment.barcode || '-'}}
                </td>
                <td>
                  {{equipment.inventoryAssetLocation || '-'}}
                </td>
                <td>
                  {{equipment.returnDate | date:'shortDate' }}
                </td>
              </tr>
                <tr *ngIf="equipment.returned" [class.return-detail-row--select-open]="isAssignedReturnSelectOpen(equipment)">
                  <td colspan="2">
                    <b>Date Returned:</b><br />
                    <input type="date" class="form-control mt-2" [ngModelOptions]="{standalone: true}" [(ngModel)]="equipment.dateReturnedString" (ngModelChange)="changedEquipment(equipment)" [disabled]="disableReturnControls" />
                  </td>
                  <td colspan="2">
                    <b>Return To Location:</b><br>
                    <p-select styleClass="app-select mt-2" [options]="locationList" [(ngModel)]="equipment.assetLocationID" (ngModelChange)="changedEquipment(equipment)" [ngModelOptions]="{standalone: true}" placeholder="Select location..." [disabled]="disableReturnControls" [filter]="true" [resetFilterOnHide]="true"
                      (onShow)="onAssignedReturnSelectShow(equipment)" (onHide)="onAssignedReturnSelectHide(equipment)"></p-select>
                    <small *ngIf="showErrors && !equipment.assetLocationID" class="text-danger">Return-to location is required</small>
                  </td>
                  <td colspan="1">
                    <b>Status:</b><br>
                    <p-select styleClass="app-select mt-2" [options]="returnStatusOptions" [(ngModel)]="equipment.assetReturnStatusID" (ngModelChange)="changedEquipment(equipment)" [ngModelOptions]="{standalone: true}" [disabled]="disableReturnControls"
                      (onShow)="onAssignedReturnSelectShow(equipment)" (onHide)="onAssignedReturnSelectHide(equipment)"></p-select>
                  </td>
                  <td colspan="1">
                    <b>Condition:</b><br>
                    <p-select *ngIf="equipment.requireItemCondition && (equipment.allowedAssetItemConditions?.length > 0)"
                              styleClass="app-select mt-2"
                              [options]="equipment.allowedAssetItemConditions"
                              optionLabel="assetItemCondition"
                              optionValue="id"
                              [(ngModel)]="equipment.assetItemConditionID"
                              (ngModelChange)="changedEquipment(equipment)"
                              [ngModelOptions]="{standalone: true}"
                              [disabled]="disableReturnControls"
                              (onShow)="onAssignedReturnSelectShow(equipment)" (onHide)="onAssignedReturnSelectHide(equipment)"></p-select>
                    <small *ngIf="showErrors && equipment.requireItemCondition && (equipment.allowedAssetItemConditions?.length > 0) && !equipment.assetItemConditionID"
                           class="text-danger">Condition is required</small>
                  </td>
                  <td colspan="2">
                    <b>Return Note:</b><br>
                    <textarea class="form-control"  [ngModelOptions]="{standalone: true}" [(ngModel)]="equipment.returnNotes" (ngModelChange)="changedEquipment(equipment)" [disabled]="disableReturnControls"></textarea>
                    <small *ngIf="showErrors && (!equipment.returnNotes || !equipment.returnNotes.trim())" class="text-danger">Return note is required</small>
                  </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="row mb-4">
            <div class="col-12">
                <small *ngIf="showErrors && !returningEquipments.length && !barcodeOnlyReturns.length" class="text-danger">Select at least one asset to return</small>
            </div>
        </div>
        </ng-container>
        <div *ngIf="hasPartialReturnKits" class="alert alert-warning py-2">
          <div><b>Partial kit return detected.</b> One or more grouped kits are being returned incompletely.</div>
          <div class="small mt-1" *ngFor="let summary of partialReturnKitSummaries">
            {{summary.groupName}}: returning {{summary.selectedCount}} of {{summary.expectedCount}}
          </div>
        </div>
      </div>
    </div>

    <details class="mt-3">
      <summary><b>Re-Assign</b></summary>
      <div class="row mt-2">
        <div class="col-12 col-xl-3">
          <label>Assignment Type</label>
          <p-select styleClass="app-select mt-2"
                    [options]="[{label:'User', value:'user'},{label:'Campus', value:'campus'}]"
                    [(ngModel)]="reassignTargetType"
                    (ngModelChange)="changedReassignTargetType()"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="disableReturnControls"></p-select>
        </div>
        <div class="col-12 col-xl-6" *ngIf="reassignTargetType === 'user'">
          <label>User</label>
          <p-select styleClass="app-select mt-2"
                    [options]="usersList"
                    [(ngModel)]="reassignToUserID"
                    (ngModelChange)="changedReassignTarget()"
                    [filter]="true"
                    [resetFilterOnHide]="true"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Select user..."
                    [disabled]="disableReturnControls"></p-select>
        </div>
        <div class="col-12 col-xl-6" *ngIf="reassignTargetType === 'campus'">
          <label>Campus</label>
          <p-select styleClass="app-select mt-2"
                    [options]="reassignCampusList"
                    [(ngModel)]="reassignToProgramID"
                    (ngModelChange)="changedReassignTarget()"
                    [filter]="true"
                    [resetFilterOnHide]="true"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Select campus..."
                    [disabled]="disableReturnControls"></p-select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-xl-3">
          <label>Return Date</label>
          <input type="date"
                 class="form-control mt-2"
                 [(ngModel)]="reassignReturnDateString"
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="disableReturnControls || !hasReassignTarget" />
        </div>
        <div class="col-12 col-xl-9">
          <label>Notes</label>
          <textarea class="form-control mt-2"
                    rows="2"
                    [(ngModel)]="reassignNote"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="disableReturnControls || !hasReassignTarget"></textarea>
        </div>
      </div>
      <small *ngIf="reassignErrorMessage" class="text-danger">{{reassignErrorMessage}}</small>
    </details>

    <div class="return-footer-actions float-right">
      <i *ngIf="savingReturnEquipments" class="material-icons rotate text-muted">loop</i>
      <button *ngIf="!savingReturnEquipments" class="btn btn-primary" (click)="requestSave()" [disabled]="disableReturnControls">{{submitActionLabel}}</button>
    </div>

  </div>
</form>

<p-dialog [showHeader]="false" [modal]="true" appendTo="body" [style]="{width: '1000px', maxWidth: '96vw'}"
          [closable]="!disableReturnControls" [dismissableMask]="!disableReturnControls" [closeOnEscape]="!disableReturnControls"
          [(visible)]="showReturnConfirmDialog">
  <div class="confirm-dialog-content">
    <div class="confirm-dialog-title">Confirm Return</div>
    <p class="confirm-dialog-hint mb-3">
      Review the returns below. Return notes are required and can still be edited before confirmation.
    </p>

    <p-table [value]="getAllReturns()" [responsive]="true" styleClass="small-Text">
      <ng-template pTemplate="header">
        <tr>
          <th>Assignee</th>
          <th>Description</th>
          <th>Return To Location</th>
          <th>Status</th>
          <th>Condition</th>
          <th width="260px">Return Note</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{getReturnAssigneeLabel(item)}}</td>
          <td>{{getReturnDescription(item)}}</td>
          <td>{{getLocationLabel(item.assetLocationID)}}</td>
          <td>{{getReturnStatusLabelForItem(item)}}</td>
          <td>{{getConditionLabelForItem(item)}}</td>
          <td>
            <textarea class="form-control" [(ngModel)]="item.returnNotes" [ngModelOptions]="{standalone: true}" rows="2" [disabled]="disableReturnControls"></textarea>
            <small *ngIf="showErrors && (!item.returnNotes || !item.returnNotes.trim())" class="text-danger">Return note is required</small>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div *ngIf="hasReassignTarget" class="mt-3">
      <p class="confirm-dialog-hint mb-2">
        Re-assignment details. New return date and note can still be edited before confirmation.
      </p>
      <table class="table table-sm table-striped mb-0">
        <tbody>
          <tr>
            <th style="width: 220px;">New Assignee</th>
            <td>{{getReassignAssigneeLabel()}}</td>
          </tr>
          <tr>
            <th>New Return Date</th>
            <td>
              <input type="date"
                     class="form-control"
                     [(ngModel)]="reassignReturnDateString"
                     [ngModelOptions]="{standalone: true}"
                     [disabled]="disableReturnControls" />
            </td>
          </tr>
          <tr>
            <th>New Assign Note</th>
            <td>
              <textarea class="form-control"
                        rows="2"
                        [(ngModel)]="reassignNote"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="disableReturnControls"></textarea>
            </td>
          </tr>
        </tbody>
      </table>
      <small *ngIf="showErrors && reassignErrorMessage" class="text-danger">{{reassignErrorMessage}}</small>
    </div>

    <div *ngIf="hasPartialReturnKits" class="alert alert-warning mt-3 mb-0 py-2">
      <div><b>Partial kit return confirmation.</b> The following grouped kits are not complete in this return:</div>
      <div class="small mt-1" *ngFor="let summary of partialReturnKitSummaries">
        {{summary.groupName}}: returning {{summary.selectedCount}} of {{summary.expectedCount}}
      </div>
    </div>

    <div class="text-right mt-3">
      <button class="btn btn-primary mr-2" (click)="save()" [disabled]="disableReturnControls">Yes</button>
      <button class="btn btn-secondary" (click)="cancelSave()" [disabled]="disableReturnControls">No</button>
    </div>
  </div>
</p-dialog>
